<template>
    <div class="module-selector ui-select" :class="{ 'ui-form-selector': visible }" :style="{ width: width }" ref="container" @click="methods.show">
        <!-- * 主体 -->
        <input class="module-input ui-form-control" type="text" readonly :placeholder="placeholder" />
        <ui-icon class="module-arrow ui-select-arrow" name="arrow" />

        <!-- * 选择项 -->
        <div class="module-selecteds">
            <div class="module-selected" v-for="(value, key) in modelValue" :key="key" @click.stop>
                <div class="module-context">{{ value }}</div>
                <ui-icon class="module-close" name="close" @click="methods.selected(value)" />
            </div>
        </div>

        <!-- * 候选项 -->
        <Transition v-on="ons.animation">
            <div class="module-options ui-form-candidates" ref="candidates" v-if="visible" @click.stop>
                <div class="module-options-triangle ui-form-candidates-triangle"></div>
                <div class="ui-form-candidate-container">
                    <div class="ui-form-candidate-content module-error" v-if="!option.length">{{ $t("NoData") }}</div>
                    <div class="ui-form-candidate-content module-options-content" v-else>
                        <template v-for="value in option" :key="value.value">
                            <div
                                class="module-option ui-checkbox ui-form-candidate"
                                :class="utils.get_option_class(value.value)"
                                @click="methods.selected(value.value)">
                                <div class="ui-checkbox-control">
                                    <input type="checkbox" class="ui-checkbox-input" :value="value" :checked="modelValue.includes(value.value)" />
                                    <ui-icon name="success" class="ui-checkbox-icon" />
                                </div>

                                <div class="ui-checkbox-content">{{ value.value }}</div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 组件属性
import { ModuleEmits, ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";

//* 组件属性注册
const emits = defineEmits(ModuleEmits);
const define = defineProps(ModulePropsOption);

//* 组合函数
const { ons, refs, nodes, utils, methods, computeds } = useComposable(define, emits);
const { placeholder } = computeds;
const { candidates, container } = nodes;
const { visible } = refs;
</script>

<style lang="less" scoped>
.module-selector {
    cursor: pointer;
    position: relative;
    .module-input {
        width: 100%;
    }

    .module-options {
        top: 100%;
        width: 100%;
        z-index: 6;
        transform: translateY(12px);
        .module-error {
            padding: 8px 16px;
        }

        .module-option {
            display: flex;
            margin: 0;
            &.ui-active,
            &.ui-disabled-status {
                background-color: #fff;
            }

            &.ui-disabled-status {
                cursor: default;
            }

            &:not(.ui-disabled-status):hover {
                background: var(--uioption-form-candidate-active-background-color);
                color: var(--uioption-form-candidate-active-color);
            }
        }

        .module-options-content {
            max-height: 256px;
        }

        .module-options-triangle {
            top: 0;
            left: 20px;
            position: absolute;
            transform: translateY(-100%);
            border-style: solid;
            border-width: 0 6px 10px 6px;
            border-color: transparent transparent var(--uioption-form-color) transparent;
            &::before {
                left: -5px;
                bottom: -10px;
                content: "";
                position: absolute;
                border-style: solid;
                border-width: 0 5px 9px 5px;
                border-color: transparent transparent #fff transparent;
            }
        }
    }

    .module-selecteds {
        line-height: 40px;
        flex-wrap: wrap;
        position: absolute;
        overflow: hidden;
        padding: 0 46px 0 10px;
        display: flex;
        height: 40px;
        width: 100%;
        left: 0;
        top: 0;
        .module-selected {
            cursor: auto;
            margin: 6px;
            display: flex;
            padding: 0 8px;
            transition: all 0.3s;
            line-height: 28px;
            align-items: center;
            border-radius: 4px;
            background-color: var(--uicolor-font-4-02);
            .module-close {
                color: var(--uicolor-font-1);
                cursor: pointer;
                font-size: 18px;
                transition: all 0.3s;
                background: var(--uicolor-font-4-05);
                margin-left: 8px;
                border-radius: 50%;
            }
        }

        .module-selected:hover {
            color: var(--uicolor-main-active-color);
            background-color: var(--ui-color-4);
        }
    }
}

.module-selector:hover {
    .module-input {
        border-color: var(--uicolor-main-color);
    }
}
</style>
